import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "./Header.css";

const Header = () => {
  const { user, logout } = useAuth();
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode);
    document.body.classList.toggle("light-theme");
  };

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <header className="header">
      <nav className="navbar">
        <div className="navbar-container">
          {/* Brand Logo */}
          <Link className="navbar-brand" to="/">
            <span className="logo-text">Ladder</span>
            <span className="logo-highlight">Up</span>
          </Link>

          {/* Desktop Nav */}
          <div className={`nav-links ${isMenuOpen ? "active" : ""}`}>
            <Link
              to="/"
              className={`nav-link ${location.pathname === "/" ? "active" : ""}`}
            >
              Home
            </Link>
            <Link
              to="/about"
              className={`nav-link ${
                location.pathname === "/about" ? "active" : ""
              }`}
            >
              About
            </Link>
            <Link
              to="/jobs"
              className={`nav-link ${
                location.pathname === "/jobs" ? "active" : ""
              }`}
            >
              Jobs
            </Link>
            <Link
              to="/contact"
              className={`nav-link ${
                location.pathname === "/contact" ? "active" : ""
              }`}
            >
              Contact
            </Link>

            {/* Auth Section */}
            {user ? (
              <div className="auth-section">
                <span className="profile-name">👤 {user.name}</span>
                <button
                  className="logout-btn"
                  onClick={() => {
                    logout();
                    navigate("/");
                  }}
                >
                  Logout
                </button>
              </div>
            ) : (
              <div className="auth-section">
                <Link to="/login" className="btn primary">
                  Login
                </Link>
                <Link to="/register" className="btn secondary">
                  Sign Up
                </Link>
              </div>
            )}

            {/* Theme Toggle */}
            <button className="theme-toggle" onClick={toggleTheme}>
              {isDarkMode ? "🌙" : "☀️"}
            </button>
          </div>

          {/* Hamburger Menu */}
          <button
            className={`hamburger ${isMenuOpen ? "open" : ""}`}
            onClick={toggleMenu}
          >
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </button>
        </div>
      </nav>
    </header>
  );
};

export default Header;
